import cssUtil from 'edge/api/gw-portals-util-js/CssUtil';
import template from 'text!./psa-start-new-fnol.html';
import controller from './StartNewFNOL_PSA';
import style from 'edge/gateway/contacts/common/components/StartNewQuote/startNewQuote-hashed.scss'; // PSA reuse CSS

export default {
    controller,
    template: cssUtil.hashTemplate(template, style),
};
